module.exports = __webpack_public_path__ + "img/sort.30024235.jpg";